import DiscoContainerButton from "@disco-ui/button/DiscoContainerButton"
import { TestIDProps } from "@utils/typeUtils"
import classNames from "classnames"
import classes from "./DiscoMultiSelectFilters.module.css"

export interface DiscoMultiSelectFiltersProps<T extends string> extends TestIDProps {
  selectedFilter?: T
  setFilter?: (filter: T) => void
  filters?: {
    value: T
    title: string
  }[]
  classes?: {
    filters?: string
  }
}

function DiscoMultiSelectFilters<T extends string = string>({
  selectedFilter,
  setFilter,
  filters,
  classes: propClasses,
}: DiscoMultiSelectFiltersProps<T>) {
  if (!filters?.length) return null

  return (
    <div className={classNames(classes.filters, propClasses?.filters)}>
      {filters.map((filter) => (
        <DiscoContainerButton
          key={filter.value}
          onClick={(e) => {
            e.preventDefault()
            e.stopPropagation()
            setFilter?.(filter.value)
          }}
          className={classNames(
            classes.filter,
            selectedFilter === filter.value && classes.selectedFilter
          )}
        >
          {filter.title}
        </DiscoContainerButton>
      ))}
    </div>
  )
}

export default DiscoMultiSelectFilters
